<template>
    <div class="payout-method g-mb-4 g-p-5">
        <g-media-object vertical-align="center">
            <div slot="left">
                <div class="payout-method__card-image-wrapper">
                    <img :src="brandLogo" class="payout-method__card-image" />
                </div>
            </div>

            <g-typography :value="cardDetails" />

            <g-tag v-if="delivered && pendingActivation" theme="warning" class="g-ml-3">Pending Activation</g-tag>

            <div slot="right">
                <g-typography v-if="isDefault" color="orange-5" font-weight="semibold" size="h5" class="g-mr-2">
                    <g-icon name="star" type="solid" size="xsmall" class="g-mr-2" />Default
                </g-typography>

                <g-button v-if="allowEditing" size="small" theme="live" shape="round" @click="handleEdit()">
                    Edit
                </g-button>
            </div>
        </g-media-object>
    </div>
</template>

<script>
    import { computed } from 'vue-demi';
    import {
        PAYOUT_METHOD_TYPE_CARD,
        GRIN_CARD_STATUS_ACTIVE,
        GRIN_CARD_STATUS_INACTIVE,
        GRIN_CARD_DISPLAY_NAME,
        GRIN_CARD_SHIPPING_STATUS_DELIVERED
    } from '../../../../../app-v2/constants/payouts';

    export default {
        name: 'PayoutMethod',
        props: {
            payoutMethod: {
                type: Object,
                default: null
            },
            grinCard: {
                type: Boolean,
                default: false
            },
            isDefault: {
                type: Boolean,
                default: false
            }
        },
        setup(props, context) {
            const handleEdit = () => {
                context.emit('edit');
            };

            const cardDetails = computed(() => {
                if (props.payoutMethod) {
                    const number = `••••${props.payoutMethod.last4}`;

                    if (props.payoutMethod.type === PAYOUT_METHOD_TYPE_CARD) {
                        const name = props.grinCard ? GRIN_CARD_DISPLAY_NAME : props.payoutMethod.brand.toUpperCase();
                        const expiration = `Exp ${expirationToString(props.payoutMethod.expiration_month, props.payoutMethod.expiration_year)}`;

                        return `${name} ${number}, ${expiration}`;
                    }

                    return `${props.payoutMethod.name} ${number}`;
                }
                return '';
            });

            const allowEditing = computed(() => {
                return !props.grinCard || (props.grinCard && props.payoutMethod?.status === GRIN_CARD_STATUS_ACTIVE);
            });

            const pendingActivation = computed(() => {
                return props.grinCard && props.payoutMethod?.status === GRIN_CARD_STATUS_INACTIVE;
            });

            const delivered = computed(() => {
                return props.grinCard && props.payoutMethod?.shipping_status === GRIN_CARD_SHIPPING_STATUS_DELIVERED;
            });

            const brandLogo = computed(() => {
                return props.payoutMethod?.brand_logo;
            });

            const expirationToString = (month, year) => {
                return month.toString().padStart(2, '0') + '/' + year.toString().slice(-2);
            };

            return {
                cardDetails,
                brandLogo,
                pendingActivation,
                allowEditing,
                delivered,

                handleEdit
            };
        }
    };
</script>

<style lang="scss" scoped>
    .payout-method {
        border: 1px solid $g-color-grey-4;
        border-radius: $g-border-radius-md;

        .payout-method__card-image-wrapper {
            height: 24px;
            width: 38px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid $g-color-grey-4;
            border-radius: $g-border-radius-md;

            .payout-method__card-image {
                max-height: 22.5px;
                max-width: 38px;
                border-radius: $g-border-radius-md;
            }
        }
    }
</style>
